
import { AuthService, BookYearService } from "@/services";
import { DashboardIframeData } from "@/utils/dashboard/dashboard-iframe-data";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { processIframeUrl } from "@/utils/iframe";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			data: new DashboardIframeData(),
			childOrigin: ""
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
		editMode: Boolean,
	},
	computed: {
		url():string{
			return processIframeUrl(this.data.Url, {
				useElectronServerAsProxy: this.data.UseDesktopAppAsProxy
			});
		},
		styleOverride():any {
			let result:any = {};
			if (this.data.NoBorder) {
				result.border = "none";
			}
			return result;
		}
	},
	watch: {
		"item.Data": {
			immediate: true,
			handler(){
				if (!this.item.Data){
					this.data = new DashboardIframeData();
					return;
				}
				this.data = new DashboardIframeData(this.item.Data.getJSON());
			}
		}
	},
	methods: {
		sendAppData(frame: HTMLIFrameElement) {
			if (!this.childOrigin) return;
			let app = {
				bookyear: BookYearService.selectedBookYear,
				dossier: AuthService.wfDossier.id,
				userId: AuthService.wfUser.ID,
				accessToken: AuthService.tokenStore.getSelectedToken().token,
				socketId: AuthService.tokenStore.socketId
			};
			frame.contentWindow?.postMessage({app}, this.childOrigin);
		},
		async onMessage(e: MessageEvent){
			if (e.data?.type === "IFRAME_READY") {
				this.childOrigin = e.origin;
				let frame = this.$refs.frame as HTMLIFrameElement;
				if(frame){
					setTimeout(()=>{
						this.sendAppData(frame);
					},150);
				}
			}

			if (e.data?.type === "REQUEST_TOKEN") {
				// ALWAYS force token refresh when explicitly requested (e.g., after 401 errors)
				// This ensures we get a fresh token with an active session, not just checking expiry time
				await AuthService.refreshTokens();
				let frame = this.$refs.frame as HTMLIFrameElement;
				if(frame){
					this.sendAppData(frame);
				}
			}
		},
	},
	mounted(){
		window.addEventListener("message", (e) => {
			this.onMessage(e);
		});
	},
	beforeDestroy() {
		window.removeEventListener("message", this.onMessage);
	}
});
